import { Empty, Typography } from 'antd';

export const tableLocaleSettings = {
  emptyText: (
    <Empty
      description={<Typography.Text>Здесь будут отображаться все операторы платформы Верум Логистика</Typography.Text>}
    />
  ),
};
